__turbopack_context__.v({
  "HomePageSection": "JVhnua_HomePageSection",
  "topPadding": "JVhnua_topPadding",
});
